//------------------------------------------------------------------------
// Map info box toggle buttons
//------------------------------------------------------------------------
import ExpandToggle from "@threespot/expand-toggle";

let mapToggle = document.querySelector(".Map-toggle");

if (mapToggle) {
  let expandButton = new ExpandToggle(mapToggle);
  let mapInfo = document.querySelector(".Map-info");

  let collapseInfo = function() {
    let isExpanded = mapToggle.getAttribute("aria-expanded") == "true";
    if (isExpanded) {
      expandButton.collapse();
    }
  };

  // Instead of adding a lot of complexity to allow multiple expand toggles,
  // we’re triggering a click on the main toggle when the close button is clicked.
  // This would not scale well on a large site but works fine for this use case.
  let closeBtn = document.querySelector(".Map-info-close");
  if (closeBtn) {
    closeBtn.addEventListener("click", function() {
      collapseInfo();
    });
  }

  // Close info if click off of it
  window.addEventListener("click", (evt) => {
    if (
      !evt.target.closest(".Map-toggle") &&
      !evt.target.closest(".Map-info")
    ) {
      collapseInfo();
    }
  });

  // Close with escape key
  window.addEventListener("keydown", (evt) => {
    if (evt.which === 27) {
      collapseInfo();
    }
  });

  // Start expanded
  expandButton.expand();
}

